import React from "react";
import { Link } from "react-router-dom";
import profileIcon from "../../images/icon/profile-circle.svg";
import { siteBlogPosts } from "../../config/blogs";

const Icons = {
  search: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M14.002 5H20.002" stroke="#00020F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.002 8H17.002" stroke="#00020F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M21.002 11.5C21.002 16.75 16.752 21 11.502 21C6.25195 21 2.00195 16.75 2.00195 11.5C2.00195 6.25 6.25195 2 11.502 2"
        stroke="#00020F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22.002 22L20.002 20" stroke="#00020F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

const categoryLabels = siteBlogPosts.map((post) => ({
  label: post.category.replace(/\b\w/g, (char) => char.toUpperCase()),
  count: 1,
}));

const BlogSidebar: React.FC = () => {
  return (
    <div className="col-lg-4 mt-50">
      <div className="sidebar">
        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Search</h3>
          <div className="form-group">
            <input className="form-control" type="search" placeholder="Search..." />
            <button type="submit" className="search_icon">
              <span>{Icons.search}</span>
            </button>
          </div>
        </div>

        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Related posts</h3>
          <ul className="recent_post_block list-unstyled">
            {siteBlogPosts.map((post) => (
              <li className="recent_post_item xb-border" key={post.id}>
                <h3 className="post-title border-effect-2">
                  <Link to="/blog-details">{post.title}</Link>
                </h3>
                <span>
                  <img src={profileIcon} alt="" aria-hidden="true" /> By {post.author}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Categories</h3>
          <ul className="category_list_block list-unstyled">
            {categoryLabels.map((category) => (
              <li key={category.label}>
                <Link to="/blog">
                  <span>
                    <i className="far fa-arrow-right"></i> {category.label}
                  </span>
                  <span>({String(category.count).padStart(2, "0")})</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="sidebar_widget">
          <h3 className="sidebar_widget_title">Tags</h3>
          <ul className="tags_block list-unstyled">
            {["Web Design", "Mobile Apps", "E-Commerce"].map((tag) => (
              <li key={tag}>
                <Link className="xb-border" to="/blog">
                  {tag}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;
